/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ViewTableIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'View Table',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M33 2H3a1 1 0 0 0-1 1v7h32V3a1 1 0 0 0-1-1ZM33 34H14v-6h20v5a1 1 0 0 1-1 1ZM12 34H3a1 1 0 0 1-1-1v-5h10v6ZM14 12h20v6H14zM14 20h20v6H14zM2 12h10v6H2zM2 20h10v6H2z"
    />
  </svg>`;
};
